import TooltipRegistry from './TooltipRegistry';

const useTooltipContent = (contentId) => 
    TooltipRegistry.instance().getContentObject( contentId ).content;

export default useTooltipContent;
